//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['data'],
  methods: {
    selectContact: function selectContact(userId) {
      this.$emit('select-contact', userId);
    }
  }
};